// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /contest/correction-review-get.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeContestCorrectionReviewGetBody,
  typeContestCorrectionReviewGetOutput200,
} from "../../sdk/contest/postContestCorrectionReviewGet";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildContestCorrectionReviewGetQueryKey(
  payload: typeContestCorrectionReviewGetBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`poolId:${JSON.stringify(payload.poolId)}`);
  queryKeySegments.push(`contestId:${JSON.stringify(payload.contestId)}`);
  return [
    "post:contest:contestCorrectionReviewGet",
    "svc:contest-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeContestCorrectionReviewGetOutput200,
    unknown,
    typeContestCorrectionReviewGetOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useContestCorrectionReviewGet(
  payload: typeContestCorrectionReviewGetBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildContestCorrectionReviewGetQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postContestCorrectionReviewGet(payload),
    ...resolvedOptions,
  });
}
